import { useEffect, useRef, useState } from "react";
import { Box, Flex, Paper, Title, Button, Stack, Text, Group } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import axios from "axios";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import { BASE_API_CLIENT_URL } from "../../../config";

export default function ClearCache() {
  const [height, setHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClearCache = async () => {
    setLoading(true);
    const prefix = "Hacom-api-web-Category-";
    const apiUrl = `${BASE_API_CLIENT_URL}/Cache/delete-cache-prefix?prefix=${prefix}`;
    try {
      const res = await axios.get(apiUrl);

      if (res && (res.status === 200 || res.data?.success)) {
        NotificationExtension.Success(res.data?.message || "Xóa cache thành công!");
      } else {
        NotificationExtension.Fails(res?.data?.message || "Xóa cache thất bại.");
      }
    } catch (err: any) {
      console.error(err);
      const errMsg = err?.response?.data?.message || err?.message || "Đã xảy ra lỗi khi xóa cache.";
      NotificationExtension.Fails(errMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        border: "1px solid #dee2e6",
        padding: 10,
        overflow: "hidden",
        height: height,
      }}
      ref={headerRef}
    >
      <Flex
        gap="md"
        justify="space-between"
        align="center"
        direction="row"
        wrap="wrap"
        w="100%"
      >
        <BreadCrumb />
      </Flex>
      <Box mt={30} style={{ maxWidth: 500 }}>
        <Paper shadow="xs" p="xl" withBorder>
          <Stack gap="md">
            <Title order={3}>Xóa Cache Hệ Thống</Title>
            

            <Group justify="flex-start" mt="md">
              <Button
                leftSection={<IconTrash size={16} />}
                color="red"
                size="md"
                loading={loading}
                onClick={handleClearCache}
              >
                Xóa Cache
              </Button>
            </Group>
          </Stack>
        </Paper>
      </Box>
    </div>
  );
}
